import React from "react";
import styled from "styled-components";
import { read_timeline_value_label } from "../../../utils/timeline/timeline_formatting";

const TimelineSalesTransition = styled.p`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem;
    min-width: 0;
    > span:first-child {
        color: var(--greyDark);
        overflow-wrap: anywhere;
    }

    > span:nth-child(2) {
        color: ${p => p.theme.mid};
    }

    strong {
        color: ${p => p.theme.color};
        overflow-wrap: anywhere;
    }
`;

// Displays one previous-to-current Sales status movement.
export const Timeline_Sales_Session_Transition = (props) => {
    if (!props.statusChange) {
        return null;
    }

    return (
        <TimelineSalesTransition data-testid="timeline-sales-transition">
            <span>{read_timeline_value_label(props.statusChange.from)}</span>
            <span aria-hidden="true">→</span>
            <strong>{read_timeline_value_label(props.statusChange.to)}</strong>
        </TimelineSalesTransition>
    );
};
